"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4PriceCategory = void 0;
var GA4PriceCategory;
(function (GA4PriceCategory) {
    GA4PriceCategory["Regular"] = "regular";
    GA4PriceCategory["Special"] = "special";
    GA4PriceCategory["FriendsDiscount"] = "friends discount";
})(GA4PriceCategory || (exports.GA4PriceCategory = GA4PriceCategory = {}));
//# sourceMappingURL=GA4PriceCategory.js.map